import { render, staticRenderFns } from "./CookiebarCard.vue?vue&type=template&id=2650e0a5&"
import script from "./CookiebarCard.vue?vue&type=script&lang=js&"
export * from "./CookiebarCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports